import LegalPage from "@/components/LegalPage";

const Privacy = () => (
  <LegalPage
    title="Privacy Policy"
    updated="luglio 2026"
    description="Informativa sul trattamento dei dati personali di ORIGINI Studio Olistico ai sensi del Regolamento UE 2016/679 (GDPR)."
    url="/privacy"
  >
    <p>
      La presente informativa descrive le modalità di trattamento dei dati personali
      degli utenti che consultano il sito e che inviano una richiesta di contatto,
      ai sensi del Regolamento UE 2016/679 (“GDPR”).
    </p>

    <h2>Titolare del trattamento</h2>
    <p>
      Titolare del trattamento è <strong>Laura Casarella</strong>, titolare dello studio
      ORIGINI – Studio Olistico specializzato in Ayurveda e riflessologia plantare.
      <br />
      Via Roma 334, 35030 Montemerlo di Cervarese Santa Croce (PD)
      <br />
      Contatto: WhatsApp +39 346 153 3000
    </p>

    <h2>Dati raccolti</h2>
    <p>Attraverso il modulo di contatto raccogliamo esclusivamente:</p>
    <ul>
      <li>nome;</li>
      <li>numero di telefono;</li>
      <li>trattamento di interesse (facoltativo);</li>
      <li>contenuto del messaggio.</li>
    </ul>
    <p>
      Il sito non richiede la registrazione e non raccoglie indirizzi email. La navigazione
      può comportare la raccolta di dati tecnici e statistici come descritto nella{" "}
      <a href="/cookie-policy">Cookie Policy</a>.
    </p>

    <h2>Finalità e base giuridica</h2>
    <p>
      I dati sono trattati per rispondere alle richieste di informazioni e per la gestione
      dell'eventuale appuntamento. La base giuridica è il consenso dell'interessato
      (art. 6.1.a GDPR), prestato tramite l'apposita casella del modulo, e l'adozione di
      misure precontrattuali su richiesta dell'interessato (art. 6.1.b GDPR).
    </p>

    <h2>Modalità di contatto tramite WhatsApp</h2>
    <p>
      L'invio del modulo apre una conversazione su WhatsApp: i dati inseriti vengono quindi
      trasmessi tramite l'app di messaggistica gestita da Meta Platforms Ireland Ltd., che
      agisce come autonomo titolare/responsabile secondo le proprie condizioni. Ti invitiamo
      a consultare l'informativa privacy di WhatsApp/Meta.
    </p>

    <h2>Conservazione dei dati</h2>
    <p>
      I dati sono conservati per il tempo necessario a gestire la richiesta e l'eventuale
      relazione con l'interessato, e comunque non oltre i termini previsti dalla normativa
      vigente.
    </p>

    <h2>Comunicazione e diffusione</h2>
    <p>
      I dati non sono diffusi né ceduti a terzi per finalità di marketing. Possono essere
      trattati da fornitori tecnici (es. hosting del sito) nel rispetto della normativa.
    </p>

    <h2>Diritti dell'interessato</h2>
    <p>
      In ogni momento puoi esercitare i diritti previsti dagli artt. 15-22 del GDPR: accesso,
      rettifica, cancellazione, limitazione, opposizione e portabilità dei dati, oltre alla
      revoca del consenso. Puoi inoltre proporre reclamo all'Autorità Garante per la
      protezione dei dati personali. Per esercitare i tuoi diritti puoi contattare il Titolare
      ai recapiti sopra indicati.
    </p>

    <h2>Modifiche</h2>
    <p>
      Il Titolare si riserva di aggiornare la presente informativa. Le modifiche saranno
      pubblicate su questa pagina con la relativa data di aggiornamento.
    </p>
  </LegalPage>
);

export default Privacy;
